export default {
    auth: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'home'}
        },
        {
            icon: 'mdi-account-circle-outline',
            name: 'الملف الشخصي',
            to: {name: 'profile'}
        },
        {
            icon: 'mdi-book-multiple-outline',
            name: 'دوراتي',
            to: {name: 'my-courses'}
        },
        {
            icon: 'mdi-play-box-multiple-outline',
            name: 'الدورات التعليمية',
            to: {name: 'courses'}
        },
        {
            icon: 'mdi-account-tie-outline',
            name: 'المعلمين',
            to: {name: 'teachers'},
            show: 'showTeachers'
        },
        {
            icon: 'mdi-clipboard-text-outline',
            name: 'الامتحان اﻹلكتروني',
            to: {name: 'exams'},
            show: 'showExams',
        },
        {
            icon: 'mdi-license',
            name: 'نتائج واجباتي',
            to: {name: 'my-homeworks'},
        },
        {
            icon: 'mdi-license',
            name: 'نتائج امتحاناتي',
            to: {name: 'my-exams'},
        },
        {
            icon: 'mdi-wallet-outline',
            name: 'المحفظة الإلكترونية',
            to: {name: 'wallet'},
            show: 'showWallet',
        },
        {
            icon: 'mdi-information-outline',
            name: 'عن المنصة',
            to: {name: 'about'},
            divider: true,
        },
        {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: '/privacy-policy'
        },
        {
            icon: 'mdi-format-list-bulleted',
            name: 'شروط الاستخدام',
            to: '/terms'
        },
        {
            icon: 'mdi-help-circle-outline',
            name: 'الدعم الفني',
            to: {name: 'help'}
        }
    ],
    guest: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'welcome'}
        },
        {
            icon: 'mdi-account-plus-outline',
            name: 'حساب جديد',
            to: {name: 'register'}
        },
        {
            icon: 'mdi-login-variant',
            name: 'تسجيل الدخول',
            to: {name: 'login'}
        },
        {
            icon: 'mdi-information-outline',
            name: 'عن المنصة',
            to: {name: 'about'}
        },
        {
            icon: 'mdi-help-circle-outline',
            name: 'الدعم الفني',
            to: {name: 'help'}
        },
        {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: '/privacy-policy'
        },
        {
            icon: 'mdi-format-list-bulleted',
            name: 'شروط الاستخدام',
            to: '/terms'
        },
    ]
}